import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AssessmentJob, AssessmentJobHistoryPaged, LiveLogResponse } from '../models/chat.models';

@Injectable({
  providedIn: 'root'
})
export class AiAssessmentAdminService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl + '/admin/ai-assessment';
  }

  /**
   * Get paginated list of all assessment jobs.
   */
  getJobsPaged(page = 1, pageSize = 20): Observable<AssessmentJobHistoryPaged> {
    const params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize);
    return this.http.get<AssessmentJobHistoryPaged>(`${this.baseUrl}/jobs`, { params });
  }

  /**
   * Get a specific assessment job by ID.
   */
  getJobById(id: number): Observable<AssessmentJob> {
    return this.http.get<AssessmentJob>(`${this.baseUrl}/jobs/${id}`);
  }

  /**
   * Get live log entries since a given entry ID.
   */
  getLiveLogs(sinceId = 0): Observable<LiveLogResponse> {
    const params = new HttpParams().set('sinceId', sinceId);
    return this.http.get<LiveLogResponse>(`${this.baseUrl}/logs/live`, { params });
  }
}
